import { DocumentForm } from "~/components/form/health-profile/DocumentForm";
import { Authorize } from "~/components/permission/Authorize";
import { useDismiss } from "~/providers/DismissProvider";

export default function CreateDocument() {
    const { handleDismiss } = useDismiss();

    return (
        <Authorize ability="update" section="documents">
            <DocumentForm onRequestClose={handleDismiss} asRoute />
        </Authorize>
    );
}
